import React from "react";
import { Microphone, Record } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function EmptyState({ onRecord }) {
  return (
    <div className="grid place-items-center text-center px-6 py-24 lg:py-32">
      <div className="max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#A8FF1F] grid place-items-center">
          <Microphone size={36} weight="fill" className="text-[#0A0A0A]" />
        </div>
        <h2 className="font-display text-5xl tracking-tighter mb-3 leading-[0.95]">
          Nothing on tape.<br />Yet.
        </h2>
        <p className="text-[#9CA0A6] mb-8">
          Pick a kind, hit the green dot, and beatbox or hum. Your first layer is one tap away.
        </p>
        <Button
          onClick={onRecord}
          data-testid="empty-record-btn"
          className="bb-pill bg-[#A8FF1F] hover:bg-[#94E600] text-[#0A0A0A] h-14 px-8 font-semibold"
        >
          <Record className="mr-2" size={20} weight="fill" /> Lay first track
        </Button>
      </div>
    </div>
  );
}
